<template>
  <div>
    <h5 class="measurement-title mb-0"> {{$t('dashboard_new_evollu.parameters.frailty_phenotype')}} </h5>
    <span class="measurement-timestamp"> {{$t('checkup_plus.reports.measurements.last_measurement_date', {date: moment(data.lastMeasurementTimestamp).format('DD/MM/YYYY HH:mm')})}} </span>

    <table class="w-100">
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/frailty.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.frailty.exhaustion_criteria') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="exhaustionData">{{ exhaustionData.value }} {{exhaustionData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="exhaustionData"> <span  style="font-weight: bold">{{ exhaustionData.previousValue || "N/A" }} {{ exhaustionData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/frailty.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.frailty.physical_activity_criterion') }} </h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="physicalActivityData">{{ physicalActivityData.value }} {{physicalActivityData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="physicalActivityData"> <span  style="font-weight: bold">{{ physicalActivityData.previousValue || "N/A" }} {{ physicalActivityData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/frailty.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.frailty.weight_loss_criterion') }} </h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="weightLossData">{{ weightLossData.value }} {{weightLossData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="weightLossData"> <span  style="font-weight: bold">{{ weightLossData.previousValue || "N/A" }} {{ weightLossData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
      </tr>
    </table>

    <table class="w-100">
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/frailty.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.frailty.handgrip_strength') }}</h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="handgripData">{{ handgripData.value }} {{handgripData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="handgripData"> <span  style="font-weight: bold">{{ handgripData.previousValue || "N/A" }} {{ handgripData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/frailty.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.frailty.walking_criterion') }} </h5>
              </div>
            </div>
            <span class="card-title">
              <span v-if="walkingCriterionData">{{ walkingCriterionData.value }} {{walkingCriterionData.units}} </span>
              <span v-else>N/A</span>
            </span>
            <br>
            <span class="card-description">
              <span v-if="walkingCriterionData"> <span  style="font-weight: bold">{{ walkingCriterionData.previousValue || "N/A" }} {{ walkingCriterionData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }} </span>
            </span>
          </div>
        </td>
      </tr>
      <tr v-for="elem in data.results">
        <td colspan="2">
          <div class="measurement-card h-100 d-flex justify--space-between">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/warning_yellow.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.result') }} </h5>
              </div>
            </div>
            <span :style="{ color: elem.resultColour }">
              {{ elem.resultName }}
            </span>
          </div>

          <div class="measurement-card h-100 mt-2">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/reference_values.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.measurement_reference_values', {measurement: $t('dashboard_new_evollu.parameters.frailty_phenotype')}) }}</h5>
              </div>
            </div>
            <div>
              <table>
                <tr v-for="elem in elem.referenceValues">
                  <td>
                    {{handleReferenceValuesCriterias(elem)}}
                  </td>
                  <td>
                    {{elem.resultMatchingCriteria}}
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="measurement-card h-100 mt-2">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/info_circle.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.recommendation') }}</h5>
              </div>
            </div>
            <span class="card-text-normal">
              {{ elem.recommendations }}
            </span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      exhaustionData: null,
      physicalActivityData: null,
      weightLossData: null,
      handgripData: null,
      walkingCriterionData: null
    }
  },
  created() {
    this.data.measurementValues.forEach(elem => {
      if(elem.attributeCode === 'FA_EXHAUSTION') {
        this.exhaustionData = elem
      } else if(elem.attributeCode === 'FA_PHYSICAL_ACTIVITY') {
        this.physicalActivityData = elem
      }else if(elem.attributeCode === 'FA_WEIGHT_LOSS') {
        this.weightLossData = elem
      }else if(elem.attributeCode === 'FA_DOMINANT_STRENGTH') {
        this.handgripData = elem
      }else if(elem.attributeCode === 'FA_WALK_TIME') {
        this.walkingCriterionData = elem
      }
    })

    //console.log(this.data)
  },
  methods: {
    handleReferenceValuesCriterias(elem) {
      var str = ""
      let index = 0
      let criteriasLength = elem.criteriaList.length
      if(elem.operator === "AND") {
        elem.criteriaList.forEach(elem => {
          str+= `${elem.attributeName} ${elem.criteria} `
          ++index
          if (index < criteriasLength) {
            str += "& "
          }

        })
      }
      return str
    }
  }
}
</script>

<style scoped lang="scss">
.measurement-card {
  padding: 20px;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 15px;
  margin-bottom: 0;
}


table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
}

td {
  height: 100%;
}

table td {
  padding-bottom: 10px;
}

table tr {
  margin-bottom: 10px;
}

table td:not(:first-child) {
  padding-left: 12px;
}

</style>
